import { Container } from 'flux/utils';
import AffiliationStore from 'stores/AffiliationStore';
import GroupStore from 'groups/stores/GroupStore';
import OrganizationStore from 'stores/OrganizationStore';
import OrganizationActions from 'actions/OrganizationActions';
import React, { Component, PropTypes } from 'react';
import SchoolAdminPending from 'organizations/components/SchoolAdminPending.jsx';

class AdminVerificationPage extends Component {
  static propTypes = {
    params: PropTypes.object.isRequired,
  }

  static getStores() {
    return [AffiliationStore];
  }

  static calculateState(_, props) {
    const orgId = GroupStore.getGroupForCode(props.params.groupCode).getOrganization().id;
    return {
      affiliation: AffiliationStore.getAffiliation(orgId),
    };
  }

  componentWillMount() {
    if (!OrganizationStore.isLoaded()) {
      OrganizationActions.loadUserOrganizations();
    }
  }

  render() {
    if (this.state.affiliation) {
      return <SchoolAdminPending affiliation={this.state.affiliation} />;
    } else {
      return null;
    }
  }
}

export default Container.create(AdminVerificationPage, { withProps: true });



// WEBPACK FOOTER //
// ./src/organizations/containers/AdminVerificationPage.jsx